<template>
  <div>
    <form @submit.prevent="editAccommodation">
      <div class="col-md-10">
        <div class="form-group col mt-0">
          <label>Accommodation Hotel Name</label>
          <input
            type="text"
            class="form-control mt-2"
            placeholder="Accommodation Name"
            v-model="form.accomName"
            @input="$v.form.accomName.$touch()"
            required
          />
          <span v-if="$v.form.accomName.$dirty && $v.form.accomName.$invalid" class="text-danger d-block small p-2">
            This field is required
          </span>
        </div>

        <div class="form-group col mt-5">
          <label>Short Description for this accommodation</label>
          <textarea
            type="text"
            class="form-control mt-2"
            placeholder="Accommodation Description"
            v-model="form.shortDescription"
          ></textarea>
        </div>

        <div class="mt-5">
          <input type="hidden" v-model="form.rate" />
          <star-rating
            v-model="form.rate"
            :show-rating="false"
            :star-size="30"
            :border-width="4"
            border-color="#d8d8d8"
            :rounded-corners="true"
            :star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]"
          ></star-rating>
        </div>

        <div class="form-row align-items-center col-md-10 mt-5">
          <div class="form-group col-4">Type:</div>
          <div class="form-group col">
            <select v-model="form.accomType" class="form-control form-control-sm" required>
              <option disabled value="">-- Select accommodation type --</option>
              <option v-for="(type, index) in accomTypes" :key="index" :value="type.name">
                {{ type.name | capitalizeWord }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-row align-items-center col-md-10 mt-5">
          <div class="form-group col-4">Comfort level:</div>
          <div class="form-group col">
            <select v-model="form.accomLevel" class="form-control form-control-sm" required>
              <option disabled value="">-- Select comfort level --</option>
              <option v-for="(level, index) in accomLevels" :key="index" :value="level.name">
                {{ level.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group col mt-5">
          <label>Website link for this accommodation (optional)</label>
          <input type="text" class="form-control mt-2" placeholder="https://my-hotel.com" v-model="form.accomWebsite" />
        </div>

        <div class="mt-5">
          <input id="imageUploadBtn" type="file" multiple="multiple" accept="image/*" hidden @change="selectFile" />
          <button type="button" class="btn btn-primary" @click="chooseFiles()" :disabled="isUploading">
            Upload images
          </button>
        </div>

        <div class="row text-center w-100 mt-5">
          <div v-for="(photo, index) in form.photos" :key="index" class="col-lg-3 col-md-4 col-6">
            <div class="d-block mb-4 position-relative">
              <div class="thumbnail-delete">
                <i @click="removeImage(index)" class="icofont-close-squared-alt"></i>
              </div>
              <img class="img-fluid img-thumbnail" :src="photo" />
            </div>
          </div>
        </div>

        <button type="submit" class="btn btn-primary my-5 ml-3" :disabled="isCreating">
          <span v-if="!isCreating">Update</span>
          <span v-else>Upating...</span>
        </button>
      </div>
    </form>
    <div v-if="isUploading" class="uploading-progress border bg-dark p-3 text-white">
      <div class="position-relative">
        <p v-if="uploadProcess" class="text-white text-center mb-3">Uploading is in progress...</p>
        <p v-else class="text-white text-center mb-3">Uploading process completed!</p>
        <button @click="closeProgress()" type="button" class="close position-absolute top-0 right-0" aria-label="Close">
          <span aria-hidden="true"><i class="icofont-close-circled text-white"></i></span>
        </button>
        <div
          v-for="(image, key) in images"
          :key="key"
          class="mb-2 py-2 row px-3 align-items-center justify-content-start"
        >
          <div class="img-wrapper">
            <img width="50" height="50" v-bind:ref="'image' + parseInt(key)" />
          </div>
          <div>
            &nbsp;&nbsp;&nbsp;
            <span v-if="uploadStatus[key] == 0"> Uploading...</span>
            <span v-else-if="uploadStatus[key] == 1" class="text-success">Upload Success!</span>
            <span v-else-if="uploadStatus[key] == 2" class="text-danger">Failed to upload. </span>
            <span v-else-if="uploadStatus[key] == 3" class="text-danger">File too large! </span>
            <span v-else-if="uploadStatus[key] == 4" class="text-danger">File already exists! </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import StarRating from "vue-star-rating";
import $ from "jquery";

export default {
  name: "NewAccommodation",

  data() {
    return {
      form: {
        accomName: "",
        shortDescription: "",
        accomWebsite: "",
        accomType: "",
        accomLevel: "",
        rate: 0,
        photos: [],
      },
      images: [],

      selectedFiles: undefined,
      uploadStatus: [],
      uploadProcess: true,
      isUploading: false,
      isCreating: false,
    };
  },

  components: {
    "star-rating": StarRating,
  },

  computed: {
    ...mapGetters(["accomLevels", "accomTypes", "accommodationItemData"]),
    accomId() {
      return this.$route.params.id;
    },
  },

  validations() {
    return {
      form: {
        accomName: { required },
      },
    };
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await Promise.all([this.fetchAccommodationByName(this.accomId), this.fetchAccomLevels(), this.fetchAccomTypes()]);
      this.hideBarLoading();
      this.form = this.accommodationItemData;
    });
  },

  methods: {
    ...mapActions([
      "hideBarLoading",
      "fetchAccomLevels",
      "fetchAccomTypes",
      "updateAccommodation",
      "fetchAccommodationByName",
      "uploadAccommodationPhoto",
      "deleteAccommPhoto",
    ]),

    async editAccommodation() {
      var postData = {
        id: this.accomId,
        post: this.form,
      };
      this.isCreating = true;

      await this.updateAccommodation(postData)
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            this.$notify({ group: "alert", text: "Successfully Saved" });
            window.location.reload();
          }
          this.isCreating = false;
        })
        .catch((e) => {
          this.isCreating = false;
          this.$notify({ group: "alert", text: "Failed to Save" });
        });
    },

    chooseFiles() {
      document.getElementById("imageUploadBtn").click();
    },

    selectFile(e) {
      this.selectedFiles = e.target.files;

      //preview part
      this.isUploading = true;
      this.uploadStatus = [];

      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.uploadStatus.push(0);
        this.images.push(this.selectedFiles[i]);
        this.upload(i, this.selectedFiles[i]);
      }

      for (let i = 0; i < this.images.length; i++) {
        let reader = new FileReader(); //instantiate a new file reader
        reader.addEventListener(
          "load",
          function () {
            this.$refs["image" + parseInt(i)][0].src = reader.result;
          }.bind(this),
          false
        ); //add event listener

        reader.readAsDataURL(this.images[i]);
      }
    },

    upload(idx, file) {
      let formData = new FormData();
      formData.append("image", file);

      this.uploadAccommodationPhoto(formData)
        .then((response) => {
          // console.log(response);
          if (response.status == 200 || response.status == 201) {
            this.form.photos.push(response.data.filepath);
            this.uploadStatus[idx] = 1; // success
            this.$set(this.uploadStatus, idx, 1);
          } else if (response.data.message == "File too large!") {
            this.uploadStatus[idx] = 3; // error
            this.$set(this.uploadStatus, idx, 3);
          } else if (response.data.message == "File already exists!") {
            this.uploadStatus[idx] = 4; // error
            this.$set(this.uploadStatus, idx, 4);
          } else {
            this.uploadStatus[idx] = 2; // error
            this.$set(this.uploadStatus, idx, 2);
          }

          this.checkUploadingStatus();
        })
        .catch((error) => {
          this.uploadStatus[idx] = 2; // error
          this.$set(this.uploadStatus, idx, 2);
          this.checkUploadingStatus();
        });
    },

    checkUploadingStatus() {
      for (let i = 0; i < this.uploadStatus.length; i++) {
        if (this.uploadStatus[i] == 0) {
          return;
        }
      }
      this.uploadProcess = false;
    },

    closeProgress() {
      this.isUploading = false;
      this.images = [];
    },

    removeImage(index) {
      const dP = this;
      $.confirm({
        title: "",
        content: "Are you sure want to delete this image ?",
        buttons: {
          confirm: async () => {
            await dP
              .deleteAccommPhoto({ url: dP.form.photos[index] })
              .then((response) => {
                console.log(response);
                if (response != undefined && response.data != undefined && response.data.code == "ERR_INVALID_URL") {
                  this.$notify({ group: "alert", text: "Invalid URL Error" });
                } else {
                  dP.form.photos.splice(index, 1);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          },
          cancel: () => {},
        },
      });
    },
  },
};
</script>

<style scoped>
.uploading-progress {
  border-radius: 10px;
  position: fixed;
  bottom: 20px;
  right: 20px;
  min-width: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 90vh;
}
.uploading-progress img {
  object-fit: cover;
  border-radius: 50%;
}
</style>
